import { ButtonHTMLAttributes, forwardRef } from "react";
import { TextButton } from "./text-button";
import { cn } from "../../../utils/cn";

export const InlineTextButton = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ className, ...props }, ref) => {
    return <TextButton ref={ref} className={cn("inline", className)} {...props} />;
  },
);

InlineTextButton.displayName = "InlineTextButton";
